import PageWrapper from '@app/components/layout/PageWrapper';
import FullLoader from '@app/components/ui/FullLoader';
import InventoryPage from '@pages/inventory/InventoryPage';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';

const InventoryRoute = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('inventory-page-title')}>
        <InventoryPage />
      </PageWrapper>
    </Suspense>
  );
};

export default { InventoryRoute };
